'use strict';

/* Views */
import ServiceRequestsList from './list/service-requests-list.component';
import ServiceRequestsEdit from './edit/service-requests-edit.component';

/* Components */
import ServiceRequestInfoComponent from '../../components/service-request-info/service-request-info.component';

/* Services */
import IntegrationService from '../../services/integration/integration.service';

export default angular.module('conduuApp.serviceRequests', [ServiceRequestsList, ServiceRequestsEdit, IntegrationService,
  ServiceRequestInfoComponent])
  .name;



// WEBPACK FOOTER //
// ./client/app/service-requests/index.js